import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.JSPropUpdater = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _reactNative = require("react-native");
var _PlatformChecker = require("../reanimated2/PlatformChecker");
var JSPropUpdater = exports.JSPropUpdater = function() {
    function JSPropUpdater() {
        (0, _classCallCheck2.default)(this, JSPropUpdater);
        this._reanimatedEventEmitter = void 0;
        var reanimatedModule;
        if ((0, _PlatformChecker.nativeShouldBeMock)()) {
            reanimatedModule = JSPropUpdater._reanimatedModuleMock;
        } else {
            reanimatedModule = _reactNative.NativeModules.ReanimatedModule;
        }
        this._reanimatedEventEmitter = new _reactNative.NativeEventEmitter(reanimatedModule);
    }
    (0, _createClass2.default)(JSPropUpdater, [
        {
            key: "addOnJSPropsChangeListener",
            value: function addOnJSPropsChangeListener(animatedComponent) {
                var viewTag = (0, _reactNative.findNodeHandle)(animatedComponent);
                JSPropUpdater._tagToComponentMapping.set(viewTag, animatedComponent);
                if (JSPropUpdater._tagToComponentMapping.size === 1) {
                    this._reanimatedEventEmitter.addListener("onReanimatedPropsChange", JSPropUpdater._listener);
                }
            }
        },
        {
            key: "removeOnJSPropsChangeListener",
            value: function removeOnJSPropsChangeListener(animatedComponent) {
                var viewTag = (0, _reactNative.findNodeHandle)(animatedComponent);
                JSPropUpdater._tagToComponentMapping.delete(viewTag);
                if (JSPropUpdater._tagToComponentMapping.size === 0) {
                    this._reanimatedEventEmitter.removeAllListeners("onReanimatedPropsChange");
                }
            }
        }
    ], [
        {
            key: "_listener",
            value: function _listener(data) {
                var component = JSPropUpdater._tagToComponentMapping.get(data.viewTag);
                component && component._updateFromNative(data.props);
            }
        }
    ]);
    return JSPropUpdater;
}();
JSPropUpdater._tagToComponentMapping = new Map();
JSPropUpdater._reanimatedModuleMock = {
    addListener: function() {
        var _addListener = (0, _asyncToGenerator2.default)(function() {
            return _ts_generator(this, function(_state) {
                return [
                    2
                ];
            });
        });
        function addListener() {
            return _addListener.apply(this, arguments);
        }
        return addListener;
    }(),
    removeListeners: function() {
        var _removeListeners = (0, _asyncToGenerator2.default)(function() {
            return _ts_generator(this, function(_state) {
                return [
                    2
                ];
            });
        });
        function removeListeners() {
            return _removeListeners.apply(this, arguments);
        }
        return removeListeners;
    }()
};
